import {
  useZustandRegistrationKitStore,
  requestSelectors,
  useZustandRequestKitStore,
  HookProvider,
  useZustandNotificationKitStore,
  notificationKitSelectors,
  ENotificationType,
} from 'react-gldn-kit';
import {
  useTransportControllers,
  useCurrencies,
  useCountryInfo,
  useRegistration,
  useGoogleAuth,
} from 'react-render-hooks';
import React, { useMemo } from 'react';
import { IS_REFERRER_REGISTRATION } from 'constants/marketingTags';
import { useZustandWebConfiguration } from 'stores/configuration/store';
import { getGoogleAuthInfoSelector } from 'stores/configuration/selectors';

type Props = {
  children: React.ReactElement;
};

export const LogicProvider = ({ children }: Props) => {
  const { sendCommand } = useTransportControllers();

  const addRequestId = useZustandRequestKitStore(
    requestSelectors.addRequestKeyForLoaderAction
  );

  const removeRequestId = useZustandRequestKitStore(
    requestSelectors.removeRequestKeyForLoaderAction
  );

  const addNotification = useZustandNotificationKitStore(
    notificationKitSelectors.addNotificationAction
  );

  const googleAuth = useZustandWebConfiguration(getGoogleAuthInfoSelector);

  const googleData = useMemo(() => {
    const origin = location.origin;

    return googleAuth?.find((auth) => auth.domain === origin);
  }, [googleAuth]);

  const authFailed = () => {
    addNotification({
      uid: `auth_failed+${new Date().getTime()}`,
      text: 'errors.authFailed',
      type: ENotificationType.Error,
    });
  };

  const { sendRegistrationCommand } = useRegistration({
    isReferrer: IS_REFERRER_REGISTRATION,
    addRequestId,
    removeRequestId,
    registrationPath: `https://${window.location.host}/wss/client/registration`,
    authFailed,
    flow: 'Referrer',
  });

  // When currency id equeal 0
  const registrationLastStep = (info: {
    promo: string;
    currencyId: number;
  }) => {
    const { currencyId, promo } = info;

    const { utmMedium, utmSource, utmCampaning, clickIdCampaing } =
      useZustandRegistrationKitStore.getState();

    sendCommand('83x', {
      clickId: clickIdCampaing,
      utmMedium,
      utmSource,
      utmCampaign: utmCampaning,
      utmReferrer: document.referrer,
      promoCode: promo,
      idCurrency: currencyId,
      requestId: 1,
    });
  };

  return (
    <HookProvider
      value={{
        useTransportControllers,
        useCurrencies,
        useCountryInfo,
        sendRegistrationCommand,
        registrationLastStep,
        googleAuth: {
          useGoogleAuth,
          googleClientId: googleData?.clientId,
          googlePath: 'https://google2auth.com/loginhub/sign-in/google',
        },
      }}
    >
      {children}
    </HookProvider>
  );
};
